import React, { useEffect, useRef } from 'react'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

const AV_COLORS = [
  { bg: '#E6F1FB', tx: '#0C447C' }, { bg: '#E1F5EE', tx: '#085041' },
  { bg: '#FAEEDA', tx: '#633806' }, { bg: '#FBEAF0', tx: '#72243E' },
  { bg: '#EEEDFE', tx: '#3C3489' }, { bg: '#EAF3DE', tx: '#27500A' },
  { bg: '#FAECE7', tx: '#712B13' },
]

function initials(name) {
  return (name || '').split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase()
}

export default function MapView({ locations, candidates, statusColors, onClickCandidate }) {
  const mapContainer = useRef(null)
  const map = useRef(null)
  const markers = useRef([])

  useEffect(() => {
    if (map.current) return
    map.current = L.map(mapContainer.current).setView([40, 40], 3)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: 'OpenStreetMap'
    }).addTo(map.current)
  }, [])

  useEffect(() => {
    if (!map.current) return
    markers.current.forEach(m => m.remove())
    markers.current = []

    locations.forEach(loc => {
      if (loc.lat == null || loc.lng == null) return
      const pp = candidates.filter(c => c.location_id === loc.id)
      const count = pp.length
      if (count === 0) return
      const sc = { 'прибыл': 0, 'в пути': 0, 'ожидает': 0 }
      pp.forEach(c => { if (sc[c.status] !== undefined) sc[c.status]++ })
      const top = Object.entries(sc).sort((a, b) => b[1] - a[1])[0]
      const color = top && top[1] > 0 ? (statusColors[top[0]] || '#888') : '#888'

      const icon = L.divIcon({
        html: '<div style="width:36px;height:36px;border-radius:50%;background:' + color + ';border:3px solid white;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:white;box-shadow:0 2px 6px rgba(0,0,0,0.25)">' + count + '</div>',
        className: '',
        iconSize: [36, 36],
        iconAnchor: [18, 18],
      })

      const rows = pp.map(c => {
        const col = AV_COLORS[(c.color_index || 0) % AV_COLORS.length]
        const av = c.photo_url
          ? '<img src="' + c.photo_url + '" style="width:28px;height:28px;border-radius:50%;object-fit:cover;flex-shrink:0">'
          : '<div style="width:28px;height:28px;border-radius:50%;background:' + col.bg + ';color:' + col.tx + ';font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center;flex-shrink:0">' + initials(c.name) + '</div>'
        const dot = '<div style="width:8px;height:8px;border-radius:50%;background:' + (statusColors[c.status] || '#aaa') + ';flex-shrink:0"></div>'
        return '<div class="map-person-row" data-id="' + c.id + '" style="display:flex;align-items:center;gap:8px;padding:5px 6px;border-radius:6px;cursor:pointer;margin-bottom:2px;transition:background 0.1s" onmouseover="this.style.background=\'#f5f5f3\'" onmouseout="this.style.background=\'transparent\'">' + av + '<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + c.name + '</div><div style="font-size:10px;color:#999">' + (c.citizenship || '') + '</div></div>' + dot + '</div>'
      }).join('')

      const popup = '<div style="font-family:system-ui;padding:2px;min-width:180px">' +
        '<div style="font-size:13px;font-weight:600;margin-bottom:8px;padding-bottom:6px;border-bottom:1px solid #f0f0ec">' + (loc.icon || '📍') + ' ' + loc.name + ' <span style="font-weight:400;color:#999;font-size:11px">(' + count + ' чел)</span></div>' +
        (rows || '<div style="font-size:11px;color:#999">Нет кандидатов</div>') +
        '</div>'

      const marker = L.marker([loc.lat, loc.lng], { icon }).addTo(map.current)
      marker.bindPopup(popup, { maxWidth: 240 })

      marker.on('popupopen', function() {
        setTimeout(function() {
          document.querySelectorAll('.map-person-row').forEach(function(el) {
            el.onclick = function() {
              const id = el.getAttribute('data-id')
              const c = candidates.find(x => x.id === id)
              if (c) {
              
                onClickCandidate(c)
              }
            }
          })
        }, 200)
      })

      markers.current.push(marker)
    })
  }, [locations, candidates, statusColors, onClickCandidate])

  return (
    <div className="map-section">
      <div ref={mapContainer} className="mapbox-container" />
      <div className="map-legend">
        <div className="legend-item"><div className="legend-dot" style={{ background: '#639922' }} /> Прибыл</div>
        <div className="legend-item"><div className="legend-dot" style={{ background: '#EF9F27' }} /> В пути</div>
        <div className="legend-item"><div className="legend-dot" style={{ background: '#378ADD' }} /> Ожидает</div>
      </div>
    </div>
  )
}
